<template>
  <div class="row mt-0 mt-md-3" data-testid="permission-content">
    <div class="col-12">
      <div class="content p-2" v-html="permissionContent"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  permissionContent: string;
}>();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.content {
  border: 1px solid $pj-color-green;
  height: 50vh;
  overflow-y: auto;
  text-align: left;
  border-radius: 8px;
  font-size: 14px;
}
</style>
